import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { formatRoute } from 'react-router-named-routes';
import { useNavigate } from 'react-router-dom';
import { Button, Dialog, Grid, TextField } from '@mui/material';
import PopupTitle from '../common/popup_title';
import { END_USER_RECIPE_SINGLE_COLLECTION_ROUTE } from '../../services/routes';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { useTracker } from '../../operations/tracking_operations';
import {
  useCreateSmorgBoardMutation,
  useGetSpaceQuery,
} from '../../app/smorgAppSyncGraphQLApi';
import { healthProGroupForSpaceID } from '../../services/users';
import {
  CURRENT_SMORG_BOARD_SCHEMA_VERSION,
  defaultMenuStructureForAdditionalBoard,
} from '../../services/smorg_board';

const RecipeCollectionsNewBoardModal = ({ onDismiss }) => {
  const navigate = useNavigate();

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery();

  const { data: userProfile } = useGetUserProfileQuery();

  const [createSmorgBoard] = useCreateSmorgBoardMutation();

  const { data: healthProSpace } = useGetSpaceQuery();

  const currentHealthProGroup =
    healthProSpace && healthProGroupForSpaceID(healthProSpace.id);

  const tracker = useTracker();

  const [boardTitle, setBoardTitle] = useState('');

  const isValid = !!boardTitle;

  const onCreate = async () => {
    // setCreationInProgress(true);
    const input = {
      title: boardTitle,
      schemaVersion: CURRENT_SMORG_BOARD_SCHEMA_VERSION,
      spaceMembershipID: currentSpaceMembership?.id,
      groups: currentHealthProGroup && [currentHealthProGroup],
      // Must create a default menu, otherwise it's not obvious
      // for the user what to do with the board just created.
      menus: defaultMenuStructureForAdditionalBoard(),
    };
    const { data: newRecipesBoard } = await createSmorgBoard(input);
    tracker(
      userProfile,
      ['Recipes board created'],
      ['numRecipesBoardsCreated'],
    );
    // setCreationInProgress(false);
    const newRecipesBoardId = newRecipesBoard?.id;
    if (newRecipesBoardId) {
      navigate(
        formatRoute(END_USER_RECIPE_SINGLE_COLLECTION_ROUTE, {
          boardID: newRecipesBoard.id,
        }),
      );
    }
    onDismiss();
  };

  return (
    <Dialog
      open
      // size="md"
      PaperProps={{
        style: {
          width: '420px',
          height: '160px',
          padding: '10px',
        },
      }}
      onClose={onDismiss}>
      <Grid container>
        <Grid item xs={12}>
          <PopupTitle
            closeButtonEnabled
            onClickClose={onDismiss}
            titleText="Create new collection"
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          <TextField
            value={boardTitle}
            onChange={(ev) => {
              setBoardTitle(ev.target.value);
            }}
            autoFocus
            margin="dense"
            label=""
            type="text"
            fullWidth
            size="small"
            variant="standard"
            placeholder="e.g. My new collection"
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          <Button
            onClick={(ev) => {
              onCreate();
              ev.stopPropagation();
            }}
            variant="contained"
            size="medium"
            disabled={!isValid}
            disableElevation>
            Create
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

RecipeCollectionsNewBoardModal.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

export default RecipeCollectionsNewBoardModal;
